import React, { Component } from 'react';
import { Toast, Pagination } from 'antd-mobile';
import PDF from 'react-pdf-js';
import PropTypes from 'prop-types';
import tools from '../../utils/tools';
import { getFileBold } from '../../service/chat-service';

import styles from './styles.module.less';

const propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

/**
 * PDF 预览
 */
class FilePreview extends Component {
  constructor(props) {
    super(props);

    const fileUrl = tools.getQueryString('fileurl');

    this.state = {
      fileUrl,
      total: 0,
      fileData: null,
      selectPage: 1,
      scale: 1,
    };
  }

  componentDidMount() {
    this.loadPDF();
  }

  loadPDF = async () => {
    const { history } = this.props;
    const { fileUrl } = this.state;
    if (!fileUrl) return false;

    Toast.loading('加载中...', 10);

    const { data } = await getFileBold(fileUrl);
    const blob = new Blob([data], { type: 'application/pdf' });
    if (!blob) {
      Toast.show('加载失败');
      history.goBack();
    }

    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const fileData = reader.result;
      this.setState({ fileData });
    };

    return true;
  };

  loadPDFEnd = (page) => {
    this.setState({ total: page });
    Toast.hide();
  };

  handleChangePage = (selectPage) => {
    this.setState({ selectPage });
  };

  render() {
    const {
      total, fileData, selectPage, scale,
    } = this.state;

    return (
      <div className={styles.contentBox} id="canvas_pdf">
        {!!fileData
        && (
        <PDF
          file={fileData}
          page={selectPage}
          scale={scale}
          onDocumentComplete={this.loadPDFEnd}
        />
        )}
        <div className={styles.pagination}>
          <Pagination
            total={total}
            onChange={this.handleChangePage}
            current={selectPage}
            locale={{
              prevText: (<span className={styles.paginationButton}>上页</span>),
              nextText: (<span className={styles.paginationButton}>下页</span>),
            }}
          />
        </div>
      </div>
    );
  }
}

FilePreview.propTypes = propTypes;

export default FilePreview;
